import React from 'react';
import { useSelector } from 'react-redux';
import { BasicDropdown, FormLabel } from '../../../components';
import { inputNormalizer } from '../../../utils';
import { useCities } from "../hook"

const CityDropdown = ({ defaultValue, updateForm, customLabel }) => {
  const { options }  = useCities()
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  return (
    <>
      {
        customLabel ? customLabel : (
          <FormLabel>
            {translation.GENERAL.city[language.name]}
          </FormLabel>
        )
      }
      <BasicDropdown
        placeholder={translation.GENERAL.city_choose[language.name]}
        options={options}
        defaultValue={defaultValue}
        onChange={({ label }) => inputNormalizer(label, "city", updateForm)}
        // onChange={({ value }) => inputNormalizer(value, "city", updateForm)}
      />
    </>
  )
}

export { CityDropdown }
